// @ts-nocheck
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import cx from 'helpers/cx'

import { CoverImage } from 'js/components/CoverImage'
import { DisplayDate } from 'js/components/DisplayDate'
import { H4 } from 'js/components/Heading'
import ToggleTranslation from 'js/components/Item/components/ToggleTranslation'
import TiptapView from 'js/components/Tiptap/TiptapView'
import Truncate from 'js/components/Truncate/Truncate'
import { useSubtype } from 'js/lib/hooks/useSubtypes'

import styles from './RecommendedItem.module.css'

const RecommendedItem = ({
    entity,
    showMeta,
    showExcerpt,
    truncateTitle,
    ...rest
}) => {
    const { t } = useTranslation()

    const {
        localTitle,
        title,
        url,
        timePublished,
        startDate,
        subtype,
        featured,
        localExcerpt,
        excerpt,
        isTranslationEnabled,
    } = entity

    const { name } = useSubtype(subtype)

    const hasTranslations = !!localTitle && isTranslationEnabled

    const [isTranslated, setIsTranslated] = useState(hasTranslations)

    const translatedTitle = isTranslated ? localTitle : title
    const translatedExcerpt = isTranslated ? localExcerpt : excerpt

    const isEvent = subtype === 'event'
    const displayDate = isEvent ? startDate : timePublished

    return (
        <div {...rest} className={cx(styles.wrapper, rest.className)}>
            <div className="SuggestedItemText">
                <H4 className="SuggestedItemTitle" as={Link} to={url}>
                    {truncateTitle ? (
                        <Truncate lines={1}>{translatedTitle}</Truncate>
                    ) : (
                        translatedTitle
                    )}
                </H4>
                {showMeta && (
                    <div className="SuggestedItemMeta">
                        <DisplayDate
                            date={displayDate}
                            type={isEvent ? 'date' : 'timeSince'}
                            side="bottom"
                            hiddenPrefix={t('global.publication-date')}
                            isFocusable
                        />
                        <>&nbsp;&nbsp;•&nbsp;&nbsp;</>
                        <span>{name}</span>
                    </div>
                )}
                {showExcerpt && (
                    <Truncate lines={2}>
                        <TiptapView
                            content={translatedExcerpt}
                            contentType={'html'}
                            textSize="small"
                        />
                    </Truncate>
                )}
                {hasTranslations && (
                    <ToggleTranslation
                        isTranslated={isTranslated}
                        setIsTranslated={setIsTranslated}
                        style={{ marginTop: '4px' }}
                    />
                )}
            </div>
            <CoverImage
                url={url}
                featured={featured}
                size="cover"
                videoButtonSize="small"
                hideCaption
                className="SuggestedItemImage"
            />
        </div>
    )
}

export default RecommendedItem
